import { formatToDeAmount } from 'utils/number'
import { Choice } from 'components/Input/ChoiceGroup'

interface LoanSelectorOptions {
  amountOptions: Array<{
    min: number
    max: number
    step: number
    categories: string[]
    isMortgage?: boolean
  }>
  loanCategory: string
  isMortgageAllowed?: boolean
}
const range = (start: number, stop: number, step = 1) =>
  Array(Math.ceil((stop - start) / step))
    .fill(start)
    .map((x, y) => x + y * step)

export function getAmountOptions({
  amountOptions = [],
  loanCategory,
  isMortgageAllowed = false
}: LoanSelectorOptions): Array<Choice<number>> {
  return amountOptions
    .filter((option) =>
      option.categories ? option.categories.includes(loanCategory) : true
    )
    .filter(
      (option) => !option.isMortgage || option.isMortgage === isMortgageAllowed
    )
    .reduce((acc, amount) => {
      const { min, max, step } = amount
      const rangedArray = range(min, max + step, step) as []
      const genratedMap = rangedArray.map((value: number) => ({
        value,
        label: `${formatToDeAmount(value, 0, true)}`
      })) as []
      return acc.concat(genratedMap)
    }, [])
}
